import { render, staticRenderFns } from "./Spec-List.vue?vue&type=template&id=bae1eecc&scoped=true&"
import script from "./Spec-List.vue?vue&type=script&lang=js&"
export * from "./Spec-List.vue?vue&type=script&lang=js&"
import style0 from "./Spec-List.vue?vue&type=style&index=0&id=bae1eecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae1eecc",
  null
  
)

export default component.exports